<template>
  <v-container :style="{ minHeight: 'calc(100vh - 150px)', maxWidth: '1800px !important' }" class="pa-0 d-flex flex-column position-relative">

    <v-container
      class="align-start justify-center"
      fluid
      :class="isMobile ? 'flex-shrink-0' : 'logo-absolute'"
      :style="{minHeight: isMobile ? '150px' : 'auto'}"
    >
      <v-row class="align-start justify-center mb-2" no-gutters>
        <v-img src="assets/HPC-logo.png" contain max-width="235" />
      </v-row>
    </v-container>

    <v-container
      fluid
      class="d-flex flex-column align-center flex-grow-1 justify-center"
    >
      <v-row class="mb-2 mt-2 justify-center align-center" no-gutters>
        <v-hover v-for="(card, index) in cards" :key="index" >
          <v-col class="ma-4" v-if="!card.hidden">
            <v-hover>
              <template v-slot:default="{ isHovering, props }">
                <v-card class="mx-auto square" :class="{ bounce: isBouncing[index], 'no-hover': isBouncing[index] }"
                  width="100" :style="{
                    border: true, background: isHovering ? '#0022690f' : 'white',
                  }" v-bind="props" :disabled="card.disabled">
                  <v-img height="100" width="100" :src="card.image" @click="handleClick(index)">
                  </v-img>
                </v-card>
                <span class="text-caption ma-0 text-black font-weight-thin two-lines">{{ card.label }}</span>
              </template>
            </v-hover>
          </v-col>
        </v-hover>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import config from '../config.js';

export default {
  props: {
    isMobile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      drawer: true,
      rail: true,
      isCardDisabled: true,
      activeWindow: 'home',
      selected: false,
      username: '',
      restricted: false,
      TENANT: config.QLIK_TENANT,
      QLIK_APPID_BI: config.QLIK_APPID_BI,
      QLIK_SHEETID_BI: config.QLIK_SHEETID_BI,
      QLIK_APPID_AI: config.QLIK_APPID_AI,
      QLIK_SHEETID_AI: config.QLIK_SHEETID_AI,
      QLIK_APPID_MARKETANALYZER: config.QLIK_APPID_MARKETANALYZER,
      QLIK_SHEETID_MARKETANALYZER: config.QLIK_SHEETID_MARKETANALYZER,
      cards: [
        { label: "Digital Assistant", url: '/digital-assistant', image: "../assets/Chatbot_BG.png", disabled: false, hidden: false },
        { label: "Reisenummern Dashboard", url: '/voyage-numbers', image: "../assets/Reisenummern_BG.png", disabled: false, hidden: true },
        { label: "BI Dashboard", url: '', image: "../assets/BI_BG.png", disabled: false, hidden: false },
        { label: "AI Dashboard", url: '', image: "../assets/AI_BG.png", disabled: false, hidden: false },
        { label: "Digital Twin / Simulation", url: '/digitaltriplet', image: "../assets/Simulation_BG.png", disabled: false, hidden: false },
        { label: "Market Analyzer", url: '', image: "../assets/Marketanalysis_BG.png", disabled: false, hidden: false },
        { label: "Sharepoint", url: '/sharepoint', image: "../assets/Datahistory_BG.png", disabled: false, hidden: false },
        { label: "AIS Data Analytics (Lite Version)", url: '', image: "../assets/AIS_BG.png", disabled: false, hidden: true },
      ],
      isBouncing: [],

    };
  },
  mounted() {
    this.getUser();

    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Token ${token}`
    }

    fetch(`${config.baseURL}/api/v1/qlik_urls/`, { headers })
      .then(res => res.json())
      .then(data => {
        this.cards[2].url = data.url_bi;
        this.cards[3].url = data.url_ai;
        this.cards[5].url = data.url_marketanalyzer;

        if (data.marketanalyzer_premium === true) {
          this.cards[5].label += ' (Premium Version)'
        }
        else {
          this.cards[5].label += ' (Lite Version)'
        }

        if (data.url_reisenummern !== '') {
          this.cards[1].hidden = false
          this.cards[1].url = data.url_reisenummern
        }

        if (data.url_ais !== '') {
          this.cards[7].hidden = false
          this.cards[7].url = data.url_ais
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    async getUser() {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token not found in localStorage');
      }
      const headers = {
        Authorization: `Token ${token}`
      }

      const response = await axios.get(`${config.baseURL}/api/v1/user/me/`, { headers })
      if (response.status == 200) {
        const user_json = response.data
        this.username = user_json.first_name
        this.email = user_json.email
        this.restricted = user_json.restricted === true
      }

      if (this.restricted) {
        for (let i = 1; i < this.cards.length; i++) {
          this.cards[i].disabled = true;
        }
      }

    },
    handleClick(index) {
      this.isBouncing[index] = true;
      setTimeout(() => {
        this.isBouncing[index] = false;
        //this.$router.push(this.cards[index].url);
        window.open(this.cards[index].url, "_blank");
      }, 750);
    }
  },
};
</script>

<style scoped>
.logo-absolute {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.two-lines {
  display: inline-block;
  line-height: 1.5;
  min-height: calc(2 * 1.5em);
}

.text-color-white {
  color: white;
}

.disabled-card {
  opacity: 0.4;
  pointer-events: none;
}

.square {
  width: 100px;
  height: 100px;
  margin: 10px;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 28px;
  transition-property: box-shadow, transform;
  transition-duration: 200ms;
  transition-timing-function: ease;

  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.square:is(:hover, :focus) {
  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.25);
  transform: translateY(-10px);
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.bounce {
  animation: bounce 0.5s ease infinite;
}

.no-hover:is(:hover, :focus) {
  transform: none;
}

.rounded-image {
  border-radius: 50%;
  border: 4px solid #002394;
  object-fit: cover;
}
</style>
